import React, { ReactNode, useState } from 'react';
import { useLoadedData } from '../../../toolympus/hooks/useLoadedData';
import { DialogState, useThrottledCapture } from '../../../toolympus/components/primitives';
import { SelectItemDialog } from '../../../toolympus/components/primitives/SelectItemDialog';
import { CopDecision, CopDecisionApiPath, useCopDecisionSchema } from '../../CopDecisions/useCopDecisionsList';

const useCopDecisionSearch = () => {
  const [search,setSearch] = useState<string>("");
  const searchSubmitted = useThrottledCapture(search, 700);
  const data = useLoadedData<CopDecision[]>(`${CopDecisionApiPath}?title_search=${searchSubmitted}`, [], !!searchSubmitted);

  const schema = useCopDecisionSchema();

  return {
    data,
    search,
    schema,
    isSubmitted: search === searchSubmitted,
    setSearch,
  }
}


interface Props extends Omit<DialogState, "open"> {
  title: ReactNode;
  isLoading?: boolean;
  selectRecord: (decision: CopDecision) => void;
}

export const CopDecisionSelectionDialog = (props: Props) => {
  const data = useCopDecisionSearch();

  return (
    <SelectItemDialog
      available={data.data.data}
      close={() => props.close()}
      isOpen={props.isOpen}
      fields={[
        ["title"],
        ["decision"],
        ["decision_date"],
        ["is_published"]
      ]}
      filter={data.search}
      setFilter={v => data.setSearch(v)}
      isLoading={data.data.isLoading}
      schema={data.schema}
      title={props.title}
      select={r => props.selectRecord(r)}
      />
  );
}
